<template>
	<div>
		<nav class="nav-tabs">
			<ul>
				<li :class="[activeTabName === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs">
					<a @click.prevent="setActiveTabName(tab.name)" v-if="!tab.disabled"><i :class="tab.icon"></i> {{ tab.displayName }}</a>
				</li>
			</ul>
		</nav>

		<div class="main">
			<user-general-container
					:data-user-general="editForm.userGeneral"
					:data-user-social="editForm.userSocial"
					:data-providers="editForm.providers"
					v-if="activeTabName === 'usersGeneral' && (currentUser.id === editForm.userGeneral.id || userRoles.includes('users.update'))"
			></user-general-container>

			<user-editorial-container
					:data-user-editorials="editForm.userEditorials"
					:data-user-id="editForm.userGeneral.id"
					v-if="activeTabName === 'usersEditorial' && (currentUser.id === editForm.userGeneral.id || userRoles.includes('users.update'))"
			></user-editorial-container>
			<!--
			<user-mentions-container
					:data-user-mentions="editForm.userMentions"
					v-if="activeTabName === 'usersMentions'"></user-mentions-container>
			-->
			<user-permissions-container
					:data-available-roles="editForm.userRoles.availableRoles"
					:data-user-roles="editForm.userRoles.userRoles"
					:data-user-id="editForm.userGeneral.id"
					:data-translator-languages="editForm.userRoles.translatorLanguages"
					v-if="activeTabName === 'usersPermissions' && userRoles.includes('users.update')"
			></user-permissions-container>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			dataEditForm: {
				type: Object
			}
		},
		data() {
			return {
				editForm: this.dataEditForm,
				currentUser: this.$currentUser,
				userRoles: this.$currentUserRoles,
				tabs: [
					{
						name: 'usersGeneral',
						displayName: 'General',
						icon: 'fas fa-user',
						disabled: false
					},
					{
						name: 'usersEditorial',
						displayName: 'Editorial',
						icon: 'fas fa-pen-nib',
						disabled: false
					},
					{
						name: 'usersPermissions',
						displayName: 'Permissions',
						icon: 'fas fa-tasks',
						disabled: !this.$currentUserRoles.includes('users.update')
					},
				],
				activeTabName: null,
			}
		},
		mounted() {
			this.activeTabName = this.tabs[0].name;
		},
		methods: {
			setActiveTabName: function (name) {
				this.activeTabName = name;
			}
		}
	}
</script>
